import { useState } from "react"
import { HelpCircle } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

export function FieldTooltip({ children, ariaLabel = "More info" }) {
  const [open, setOpen] = useState(false)

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex items-center justify-center rounded-full transition focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50",
            open ? "text-foreground" : "text-muted-foreground"
          )}
          aria-label={ariaLabel}
        >
          <HelpCircle className="h-4 w-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        align="start"
        alignOffset={-8}
        className="max-w-sm border border-input bg-background p-3 text-foreground text-pretty shadow-md"
      >
        {children}
      </TooltipContent>
    </Tooltip>
  )
}
